import REDUX_OPTION from '../../constants/option'
import validatorUtil from './validators'

function validateReduxUtil (instance, options) {
  const {
    className,
    changed = {}
  } = instance
  options = options || {}
  if (!instance) {
    return
  }
  const keysToValidate = (
    options[REDUX_OPTION.KEYS_TO_VALIDATE] || Object.keys(changed || {})
  )
  // Validate every key of the given `data`
  let validation
  keysToValidate.forEach(key => {
    const validator = validatorUtil({
      key,
      className
    })
    let validationVal
    if (validator) {
      const value = changed[key]
      validationVal = validator(value, { instance })
    }
    if (validationVal && validationVal !== true) {
      validation = [
        ...(
          validation || []
        ),
        validationVal
      ]
    }
  })
  return validation
}

export default validateReduxUtil
